import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { Residence } from 'front-office/view-models/release-id-card/residence';

interface FormProps {
  onChange: (key: keyof Residence, value: Residence[keyof Residence]) => void;
  values?: Residence;
  disabled?: boolean;
}

const MunicipalityComponent = ({ onChange, values, disabled }: FormProps): React.ReactElement => {
  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Comune"
          aria-label="Comune"
          fullWidth
          disabled={disabled}
          value={values?.municipality || ''}
          onChange={(event) => {
            onChange('municipality', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="Provincia"
          inputProps={{
            maxLength: '2',
          }}
          aria-label="Provincia"
          fullWidth
          disabled={disabled}
          value={values?.province || ''}
          onChange={(event) => {
            onChange('province', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          label="CAP"
          aria-label="CAP"
          fullWidth
          disabled={disabled}
          inputProps={{ maxLength: '5', pattern: '[0-9]*' }}
          value={values?.cap || ''}
          onChange={(event) => {
            onChange('cap', event.target.value);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          aria-label="Località"
          label="Località"
          id="location"
          name="location"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.location || ''}
          onChange={(event) => {
            onChange('location', event.target.value);
          }}
          inputProps={{ maxLength: '120' }}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          aria-label="Presso"
          label="Presso"
          id="at"
          name="at"
          fullWidth
          disabled={disabled}
          type="text"
          variant="outlined"
          value={values?.at || ''}
          onChange={(event) => {
            onChange('at', event.target.value);
          }}
          inputProps={{ maxLength: '120' }}
        />
      </Grid>
    </Grid>
  );
};

MunicipalityComponent.displayName = 'Municipality residence';

const Municipality = memo(MunicipalityComponent);

export default Municipality;
